import { useContext } from "react"
import * as React from "react"
import { Context } from "../../../store/store"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	formElementChanged: Function
	validation: Object
}
const MafoQuestionFour: React.FC<MafoQuestionProps> = ({ formElementChanged, validation }) => {
	const { globalState } = useContext(Context)
	return (
		<>
			<h3 className="mb-6 text-left text-[17px]   lg:text-center lg:text-[22px]">Welche Eigenschaften des Produkts gefallen dir am meisten?(Mehrfachantwort möglich)</h3>
			<div className="mx-auto text-left lg:max-w-[100%]">
				<ElemCheckboxMafo
					label={<>Geschmackssorte</>}
					props={{
						type: "checkbox",
						name: "question4",
						value: "a",
						onClick: e => formElementChanged(e, "question4"),
					}}
					hasError={validation["invalid_question4"] ? true : false}
					className="pb-2 text-[32px] text-green lg:mt-6"
					errMsg={validation["invalid_question4_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Zero Zucker</>}
					props={{
						type: "checkbox",
						name: "question4",
						value: "b",
						onClick: e => formElementChanged(e, "question4"),
					}}
					hasError={validation["invalid_question4"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question4_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Dosenformat</>}
					props={{
						type: "checkbox",
						name: "question4",
						value: "c",
						onClick: e => formElementChanged(e, "question4"),
					}}
					hasError={validation["invalid_question4"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question4_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Angenehmes Kohlensäurelevel</>}
					props={{
						type: "checkbox",
						name: "question4",
						value: "d",
						onClick: e => formElementChanged(e, "question4"),
					}}
					hasError={validation["invalid_question4"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question4_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Preis</>}
					props={{
						type: "checkbox",
						name: "question4",
						value: "e",
						onClick: e => formElementChanged(e, "question4"),
					}}
					hasError={validation["invalid_question4"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question4_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Sonstiges</>}
					props={{
						type: "checkbox",
						name: "question4",
						required: "required",
						value: "f",
						onClick: e => formElementChanged(e, "question4"),
					}}
					className=" question4 pb-2 text-green"
				/>
				{globalState.question4.includes("f") && (
					<>
						<textarea name="question4Other" maxLength={99} className="h-[150px] w-full bg-[#F7F7F7] py-4 px-2" onChange={e => formElementChanged(e, "question4Other")}></textarea>
					</>
				)}
			</div>
		</>
	)
}

export default MafoQuestionFour
